/* eslint-disable import/prefer-default-export */
import Immutable from 'seamless-immutable';
import _ from 'lodash';
import {
  createRequestState,
  setRequestStateFinish,
  setRequestStateInProgress
} from '../../../../../utils/reducerHalpers/requestState';

const SEND_REQUEST = 'SEND_REQUEST';
const REQUEST_FINISHED = 'REQUEST_FINISHED';

const createActionName = (reducerName, name) => `app/${reducerName}/${name}`;

const createReducer = name => {
  function stateDefault() {
    return {
      ...createRequestState()
    };
  }

  const initialState = Immutable(stateDefault());
  return function reduce(state = initialState, action = {}) {
    switch (action.type) {
      case createActionName(name, SEND_REQUEST):
        return setRequestStateInProgress(state);
      case createActionName(name, REQUEST_FINISHED):
        return setRequestStateFinish(
          state,
          action.payload.codeResponse,
          action.payload.hasSuccess
        );
      default:
        return state;
    }
  };
};

export function createReduceObject(combineName, reducerName) {
  const reduceObject = {};
  reduceObject[reducerName] = createReducer(`${combineName}.${reducerName}`);
  return reduceObject;
}

export const sendRequest = reducerName => ({
  type: createActionName(reducerName, SEND_REQUEST)
});
export const requestFinished = (reducerName, codeResponse, hasSuccess) => ({
  type: createActionName(reducerName, REQUEST_FINISHED),
  payload: { codeResponse, hasSuccess }
});

// SELECTOR
export const getState = (state, reducerName) => _.get(state, reducerName);
export const selectRequestState = (state, reducerName) =>
  _.get(getState(state, reducerName), 'requestState');



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/users/common/reducers/forms/resendConfirmTokenAction.js